import SettingsDialog from "./SettingsDialog";
import AppearanceDialog from "./AppearanceDialog";
import AboutDialog from "./AboutDialog";

export {
    SettingsDialog,
    AppearanceDialog,
    AboutDialog
};